// Gatsby requirements
import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import Image from "utils/Image"
import Json from 'components/ListOfArticles/ListOfArticles.json'

// Styles
import * as CSS from './FeaturedArticle.module.scss'


const FeaturedArticle = ({ data }) => {

    const query = useStaticQuery(graphql`
        query {
            categoryTags: allStoryblokDatasourceEntry(filter: {data_source: {eq: "blog-tags"}}) {
                nodes {
                  name
                  value
                }
            }
            patientResourceTags: allStoryblokDatasourceEntry(filter: {data_source: {eq: "patient-resource-tags"}}) {
                nodes {
                    name
                    value
                }
            }
        }
    `)

    const articleUuid = data?.article?.length > 5 ? data?.article : data?.article[0];

    const article = Json?.find(({uuid}) => uuid === articleUuid)

    return (
        <section className={`${CSS.section} ${'section' + data._uid}`} {...storyblokEditable(data)}>

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid)
                }} />
            }

            <h2>{data.title}</h2>
            {article &&
                <article>
                    <div className={CSS.image}>
                        {article?.thumbnail?.filename &&
                            <Image img={article.thumbnail} />
                        }
                    </div>
                    <div className={CSS.text}>
                        <Link to={`/${article?.full_slug}/`}>
                            <h3>{article?.title}</h3>
                        </Link>
                        {article?.description &&
                            <p>{article.description}</p>
                        }
                        {article?.category && article?.category[0] &&
                            <Link className={CSS.categoryTag} to={`/learn/categories/${article.category[0]}/`}>
                                {query.categoryTags.nodes.find(({value}) => value === article.category[0])?.name}
                            </Link>
                        }
                        {article?.patientResourcesCategory && article?.patientResourcesCategory[0] &&
                            <Link className={CSS.categoryTag} to={`/patient-resources/categories/${article.patientResourcesCategory[0]}/`}>
                                {query.patientResourceTags.nodes.find(({value}) => value === article.patientResourcesCategory[0])?.name}
                            </Link>
                        }
                    </div>
                </article>
            }
        </section>
    )
}

export default FeaturedArticle